export default __webpack_public_path__ + "static/media/snackbar.0e98b17e.png";